export const dotenv = {
  API_BASE_URL: 'https://api-dev.mykinships.com',
  NOTIFICATION_BASE_URL: 'https://api-dev-notification.mykinships.com',
  FRONTEND_BASE_URL: 'https://app-dev.mykinships.com',
  MEDIA_BASE_URL: 'https://api-dev-media.mykinships.com',
  NODE_TLS_REJECT_UNAUTHORIZED: '0',
  BUCKET: 'mykinship-dev-assets',
  ENV: 'dev',
  CLOUD_FRONT_BASE_URL: 'https://d1f14w5eki3tuv.cloudfront.net/',
  ASSET_BASE_URL: 'https://mykinship-dev-assets.s3.us-east-1.amazonaws.com/',
  IS_SIGNUP_CODE_ENABLED: 'false',
  MARKETING_SITE_URL: 'https://stage.mykinships.com',
  SOCKET_URL: 'https://socket-dev.mykinships.com'
};
